module.exports = __webpack_public_path__ + "static/valence-logo-57e4149c76580076d8820b5a77efd703.png";